import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentScoreCardsReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_SCORE_CARDS}
      description="Generate printable score cards for all events in the selected tournament."
      options={[
        {
          field: 'isShowSchedule',
          label: 'Include game schedule',
          hint: 'Add the tournament game schedule to the generated document.',
          initialValue: true
        }
      ]}
    />
  );
}
